export default __webpack_public_path__ + "static/media/img-0100-china-half-face.c4df369f.png";